// extracted by css-extract-rspack-plugin
export default {"titleInput":"VQVOR","titleContainer":"SwUP_","actionsContainer":"c902v"};